import { render, staticRenderFns } from "./commonPhrases.vue?vue&type=template&id=e72222c6&scoped=true"
import script from "./commonPhrases.vue?vue&type=script&lang=js"
export * from "./commonPhrases.vue?vue&type=script&lang=js"
import style0 from "./commonPhrases.vue?vue&type=style&index=0&id=e72222c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72222c6",
  null
  
)

export default component.exports